var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSofa = function SvgSofa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E6D67",
    d: "M4.126 21.704a.703.703 0 0 1-.676-.896l.75-2.626a.703.703 0 1 1 1.351.386l-.75 2.625a.7.7 0 0 1-.675.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.875 21.704a.704.704 0 0 1-.676-.51l-.75-2.626a.703.703 0 0 1 1.352-.386l.75 2.625a.703.703 0 0 1-.676.896M17.953 2.297H6.047a3.75 3.75 0 0 0-3.75 3.75v2.578c0 .388.315.703.703.703h.188c.647 0 1.171.525 1.171 1.172V12a2.58 2.58 0 0 0 2.579 2.578h10.125A2.58 2.58 0 0 0 19.64 12v-1.5c0-.647.524-1.172 1.172-1.172H21a.703.703 0 0 0 .703-.703V6.047a3.75 3.75 0 0 0-3.75-3.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M12 13.172H6.469A1.17 1.17 0 0 1 5.297 12v-1.828a2.25 2.25 0 0 0-2.25-2.25H2.25A2.25 2.25 0 0 0 0 10.172v2.578a6.33 6.33 0 0 0 6.328 6.328H12l.703-3.106z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M21.75 7.922h-.797a2.25 2.25 0 0 0-2.25 2.25V12c0 .647-.524 1.172-1.172 1.172H12v5.906h5.672A6.33 6.33 0 0 0 24 12.75v-2.578a2.25 2.25 0 0 0-2.25-2.25"
  })));
};
export default SvgSofa;